export var VolumeType;
(function (VolumeType) {
    VolumeType["VOICE_CALL"] = "voice_call";
    VolumeType["SYSTEM"] = "system";
    VolumeType["RING"] = "ring";
    VolumeType["DEFAULT"] = "default";
    VolumeType["MUSIC"] = "music";
    VolumeType["ALARM"] = "alarm";
    VolumeType["NOTIFICATION"] = "notification";
    VolumeType["DTMF"] = "dtmf";
})(VolumeType || (VolumeType = {}));
